import {isSelectiveAiDomains} from 'common/HelperFunctions'

/**
 * Which Teacher Allocation flow the wizard shows.
 * - true: the Da1TimeTable handover flow — landing page with three methods, the shared review
 *   grid with cell settings, and Versi as a full page (components/teacherAllocation/). The
 *   wizard sidebar stays as the user left it.
 * - false: the earlier flow — the single grid page with the floating AI panel
 *   (renderLessonPlanningPlaceholder + TeacherAllocationAiPanel), kept intact, which collapses
 *   the sidebar for the wide grid.
 * Both read and write the same grid data, so switching loses nothing.
 */
export const TEACHER_ALLOCATION_V2 = true

/**
 * Within the V2 flow, whether the server holds the allocation (node-api
 * `/onboarding/allocation/*`, "Teacher Allocation (server-side): portal handoff"): every cell
 * edit is saved as it is made, the prefill, removals, undo and Versi run on the server, and
 * Continue pushes nothing. Those routes exist on the AI servers only; elsewhere (or with this
 * off) the client-side V2 flow above runs unchanged.
 */
export const TEACHER_ALLOCATION_SERVER = true

/**
 * The landing's Upload card holds the shared uploader itself — drop zone, then the reading
 * headline and a row per file with its tick — as the Upload card does on Add Teachers. Off: the
 * card has the format chips and an "Upload files" button, and the uploader sits under the cards.
 */
export const ALLOCATION_UPLOADER_IN_CARD = true

/**
 * A file read with nothing left to ask imports its assignments at once. Off: the file's line
 * shows "Import N allocations" and nothing is imported until the user clicks it.
 */
export const ALLOCATION_AUTO_IMPORT = false

/** The server answered the allocation routes with a bare 404 in this page load. */
let allocationServerMissing = false

export const markAllocationServerUnavailable = () => {
  allocationServerMissing = true
}

/** Whether Teacher Allocation should use the server-side flow on this server. */
export const allocationServerEnabled = () =>
  TEACHER_ALLOCATION_V2 &&
  TEACHER_ALLOCATION_SERVER &&
  isSelectiveAiDomains() &&
  !allocationServerMissing
